import { Injectable } from '@angular/core';
import { ApiService } from '../../api/api.service';
import { apiUrls } from '../../../config/api/api-urls.config';
import { VersionsResultsResponse } from '../../../models/versions/responses/api-versions-results-response.model';

@Injectable({
  providedIn: 'root'
})
export class ApiVersionsService {

  constructor(private apiService: ApiService) { }

  addVersion(apiVersion: string, minAppVersion: string, gameServerVersion: string, isActive: boolean): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      this.apiService.launchAdminApiRequestPost(apiUrls.versionsAddVersionUrl, { api_version: apiVersion, min_app_version: minAppVersion, game_server_version: gameServerVersion, is_active: isActive }).then(
        () => { resolve(); }, error => { reject(error); });
    });
  }

  editVersion(versionId: number, apiVersion: string, minAppVersion: string, gameServerVersion: string, isActive: boolean): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      this.apiService.launchAdminApiRequestPost(apiUrls.versionsEditVersionUrl, { version_id: versionId, api_version: apiVersion, min_app_version: minAppVersion, game_server_version: gameServerVersion, is_active: isActive }).then(
        () => { resolve(); }, error => { reject(error); });
    });
  }

  deleteVersion(versionId: number): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      this.apiService.launchAdminApiRequestPost(apiUrls.versionsDeleteVersionUrl, { version_id: versionId }).then(
        () => { resolve(); }, error => { reject(error); });
    });
  }

  getVersions(): Promise<VersionsResultsResponse> {
    return new Promise<VersionsResultsResponse>((resolve, reject) => {
      this.apiService.launchAdminApiRequestGet(apiUrls.versionsGetVersionsUrl, VersionsResultsResponse).then(
        (data: VersionsResultsResponse) => { resolve(data); }, error => { reject(error); });
    });
  }
}
